import {useCallback, useEffect, useRef, useState} from 'react'

const NO_ELEMENT_POSITION = {top: 0, left: 0}

const getElementPosition = (element) => {
    if (!element) return NO_ELEMENT_POSITION
    const boundingRect = element.getBoundingClientRect()
    return {
        left: boundingRect.left + window.scrollX,
        top: boundingRect.top + window.scrollY,
        width: boundingRect.width,
        height: boundingRect.height
    }
}

const useElementScreenPosition = () => {
    const ref = useRef()
    const [position, setPosition] = useState(getElementPosition())

    const recalculatePosition = useCallback(() => {
        setPosition(getElementPosition(ref.current))
    }, [])

    const setRef = useCallback(
        (element) => {
            if (ref.current !== element) {
                ref.current = element
                recalculatePosition()
            }
        },
        [recalculatePosition]
    )

    useEffect(() => {
        const listener = () => {
            recalculatePosition()
        }
        window.addEventListener('resize', listener, {passive: true})
        return () => {
            window.removeEventListener('resize', listener)
        }
    }, [recalculatePosition])

    return {
        setRef,
        position,
        recalculatePosition
    }
}

export default useElementScreenPosition
